import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Truck, RefreshCw, ShieldCheck, Headphones, Instagram, Quote } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const HERO = "https://images.unsplash.com/photo-1645561305502-63a9ba09ab09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwbW9kZWwlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg2MzgzNDM1fDA&ixlib=rb-4.1.0&q=85";
const EDITORIAL = "https://images.unsplash.com/photo-1543728069-a3f97c5a2f32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxoaWdoJTIwZW5kJTIwZmFzaGlvbiUyMG1vZGVsJTIwcnVud2F5fGVufDB8fHx8MTc4NjM4NDk1OXww&ixlib=rb-4.1.0&q=85";
const CAMPAIGN = "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxoaWdoJTIwZW5kJTIwZmFzaGlvbiUyMG1vZGVsJTIwcnVud2F5fGVufDB8fHx8MTc4NjM4NDk1OXww&ixlib=rb-4.1.0&q=85";

const CAT_BIG = { name: "Vestidos", img: "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGZhc2hpb24lMjBkcmVzcyUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODYzODM1NjR8MA&ixlib=rb-4.1.0&q=85" };
const CAT_A = { name: "Blazers", img: "https://images.unsplash.com/photo-1608234808654-2a8875faa7fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxibGF6ZXIlMjBqYWNrZXQlMjBmYXNoaW9uJTIwcHJvZHVjdHxlbnwwfHx8fDE3ODYzODM1NjV8MA&ixlib=rb-4.1.0&q=85" };
const CAT_B = { name: "Tricô", img: "https://images.unsplash.com/photo-1574201635302-388dd92a4c3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxrbml0d2VhciUyMHN3ZWF0ZXIlMjBmYXNoaW9ufGVufDB8fHx8MTc4NjM4MzU2NXww&ixlib=rb-4.1.0&q=85" };

const INSTA = [
  "https://images.unsplash.com/flagged/photo-1553277004-39d655b57262?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGZhc2hpb24lMjBkcmVzcyUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODYzODM1NjR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx3b21lbiUyMGZhc2hpb24lMjBkcmVzcyUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODYzODM1NjR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1593030942428-a5451dca4b42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxibGF6ZXIlMjBqYWNrZXQlMjBmYXNoaW9uJTIwcHJvZHVjdHxlbnwwfHx8fDE3ODYzODM1NjV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1608984361471-ff566593088f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxrbml0d2VhciUyMHN3ZWF0ZXIlMjBmYXNoaW9ufGVufDB8fHx8MTc4NjM4MzU2NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1608234807905-4466023792f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxzaGlydCUyMGJsb3VzZSUyMGZhc2hpb24lMjBuZXV0cmFsfGVufDB8fHx8MTc4NjM4MzU2NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1694447814836-c93ab70f7398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHx0cm91c2VycyUyMHBhbnRzJTIwZmFzaGlvbiUyMG1pbmltYWx8ZW58MHx8fHwxNzg2MzgzNTY1fDA&ixlib=rb-4.1.0&q=85",
];

const TESTIMONIALS = [
  { text: "A qualidade dos tecidos é impecável. Virei cliente fiel — cada peça parece feita sob medida.", name: "Marina L.", city: "São Paulo" },
  { text: "Alfaiataria perfeita e atendimento impecável. O blazer virou meu coringa no trabalho.", name: "Beatriz A.", city: "Belo Horizonte" },
  { text: "Embalagem linda, entrega rápida e peças que duram. Exatamente o que eu procurava.", name: "Carolina M.", city: "Curitiba" },
];

const SERVICES = [
  { icon: Truck, title: "Frete grátis", text: "Acima de R$ 499" },
  { icon: RefreshCw, title: "Trocas fáceis", text: "Até 30 dias" },
  { icon: ShieldCheck, title: "Compra segura", text: "Pagamento Stripe" },
  { icon: Headphones, title: "Atendimento", text: "Seg a sáb, 9h–18h" },
];

const fade = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1], delay: i * 0.12 } }),
};

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [arrivals, setArrivals] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } })
      .then((r) => setFeatured(r.data.slice(0, 8)))
      .catch(() => setFeatured([]));
    api.get("/products")
      .then((r) => setArrivals(r.data.slice(0, 4)))
      .catch(() => setArrivals([]));
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative h-[calc(100vh-108px)] min-h-[560px] w-full overflow-hidden">
        <motion.img initial={{ scale: 1.08 }} animate={{ scale: 1 }} transition={{ duration: 1.6, ease: [0.25, 1, 0.5, 1] }}
          src={HERO} alt="Coleção Ateliê" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121212]/50 via-[#121212]/10 to-transparent" />
        <div className="relative h-full max-w-[1500px] mx-auto px-5 md:px-10 flex flex-col justify-end pb-20 md:pb-28">
          <motion.div initial="hidden" animate="show">
            <motion.div variants={fade} custom={0} className="text-[11px] uppercase tracking-[0.3em] text-[#F8F7F4]/90 mb-6">Coleção Outono / Inverno 2026</motion.div>
            <motion.h1 variants={fade} custom={1} className="font-serif font-light text-[#F8F7F4] text-6xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tight max-w-4xl">
              O essencial,<br />reinventado
            </motion.h1>
            <motion.div variants={fade} custom={2} className="flex flex-wrap gap-4 mt-10">
              <Link to="/loja" data-testid="hero-shop-btn"
                className="group inline-flex items-center gap-3 bg-[#F8F7F4] text-[#1A1A1A] px-9 py-4 text-[11px] uppercase tracking-[0.15em] hover:bg-[#B89C65] hover:text-[#121212] transition-colors">
                Explorar coleção <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to="/loja?cat=Vestidos"
                className="inline-flex items-center gap-3 border border-[#F8F7F4]/40 text-[#F8F7F4] px-9 py-4 text-[11px] uppercase tracking-[0.15em] hover:border-[#F8F7F4] transition-colors">
                Novidades
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* SERVICES STRIP */}
      <section className="border-b border-[#E6E5E1]">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10 grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#E6E5E1]">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="flex items-center gap-4 py-7 px-2 lg:px-6 justify-center lg:justify-start">
                <Icon size={22} strokeWidth={1.3} className="text-[#B89C65]" />
                <div>
                  <div className="text-[11px] uppercase tracking-[0.12em] text-[#1A1A1A]">{s.title}</div>
                  <div className="text-xs text-[#5C5B59]">{s.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CATEGORIES — bento */}
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="flex items-end justify-between mb-14">
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Categorias</div>
            <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">Encontre o seu estilo</h2>
          </div>
          <Link to="/loja" className="hidden md:flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] text-[#5C5B59] hover:text-[#B89C65] transition-colors">
            Ver tudo <ArrowRight size={15} />
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <CatCard cat={CAT_BIG} className="lg:col-span-7 aspect-[16/12] lg:aspect-auto lg:h-[640px]" />
          <div className="lg:col-span-5 grid grid-rows-2 gap-6">
            <CatCard cat={CAT_A} className="h-[300px] lg:h-[308px]" />
            <CatCard cat={CAT_B} className="h-[300px] lg:h-[308px]" />
          </div>
        </div>
      </section>

      {/* FEATURED */}
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <div className="flex items-end justify-between mb-14">
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Seleção da estação</div>
            <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">Peças em destaque</h2>
          </div>
          <Link to="/loja" className="hidden md:flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] text-[#5C5B59] hover:text-[#B89C65] transition-colors">
            Ver tudo <ArrowRight size={15} />
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14">
          {featured.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>

      {/* EDITORIAL — filosofia */}
      <section className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
        <div className="relative h-[70vh] lg:h-auto min-h-[500px] overflow-hidden">
          <img src={EDITORIAL} alt="Editorial" className="w-full h-full object-cover" />
        </div>
        <div className="bg-[#121212] text-[#F8F7F4] flex flex-col justify-center px-6 md:px-20 py-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}>
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-6">Nossa filosofia</div>
            <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1] tracking-tight mb-8">Menos,<br />porém melhor</h2>
            <p className="text-[#F8F7F4]/60 text-base leading-relaxed max-w-md font-light">
              Acreditamos em um guarda-roupa consciente. Cada peça do Ateliê é escolhida por sua qualidade,
              durabilidade e capacidade de atravessar tendências. Alfaiataria impecável, tecidos nobres e
              acabamentos que duram anos — não estações.
            </p>
            <Link to="/loja" className="mt-10 inline-flex items-center gap-3 border border-[#F8F7F4]/30 px-9 py-4 w-fit text-[11px] uppercase tracking-[0.15em] hover:border-[#B89C65] hover:text-[#B89C65] transition-colors">
              Conheça a coleção <ArrowRight size={16} />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* NOVIDADES */}
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="flex items-end justify-between mb-14">
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Recém-chegadas</div>
            <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">Novidades no Ateliê</h2>
          </div>
          <Link to="/loja" className="hidden md:flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] text-[#5C5B59] hover:text-[#B89C65] transition-colors">
            Ver tudo <ArrowRight size={15} />
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14">
          {arrivals.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>

      {/* CAMPAIGN — full bleed */}
      <section className="relative h-[80vh] min-h-[520px] overflow-hidden">
        <img src={CAMPAIGN} alt="Campanha" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#121212]/25" />
        <div className="relative h-full max-w-[1500px] mx-auto px-5 md:px-10 flex flex-col items-center justify-center text-center">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.25, 1, 0.5, 1] }}>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#F8F7F4]/90 mb-6">Editorial de verão</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#F8F7F4] max-w-3xl mx-auto">
              A elegância mora<br />na simplicidade
            </h2>
            <Link to="/loja" className="mt-10 inline-flex items-center gap-3 bg-[#F8F7F4] text-[#1A1A1A] px-10 py-4 text-[11px] uppercase tracking-[0.15em] hover:bg-[#B89C65] hover:text-[#121212] transition-colors">
              Ver o lookbook <ArrowRight size={16} />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="text-center mb-16">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Quem veste, aprova</div>
          <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">Amado por nossas clientes</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.25, 1, 0.5, 1] }}
              className="border-t border-[#1A1A1A] pt-8">
              <Quote size={26} className="text-[#B89C65]" />
              <p className="font-serif text-xl md:text-2xl font-light leading-relaxed text-[#1A1A1A] mt-5">"{t.text}"</p>
              <div className="mt-6 text-[11px] uppercase tracking-[0.15em] text-[#5C5B59]">{t.name} — {t.city}</div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* INSTAGRAM */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10 text-center mb-12">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">@atelie</div>
          <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">Siga-nos no Instagram</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-1.5">
          {INSTA.map((src, i) => (
            <a key={i} href="#" className="group relative aspect-square overflow-hidden bg-[#EFEEEA]">
              <img src={src} alt="Instagram" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
              <div className="absolute inset-0 bg-[#121212]/0 group-hover:bg-[#121212]/40 transition-colors flex items-center justify-center">
                <Instagram size={26} className="text-[#F8F7F4] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}

function CatCard({ cat, className = "" }) {
  return (
    <Link to={`/loja?cat=${cat.name}`} data-testid={`category-${cat.name}`}
      className={`group relative overflow-hidden block ${className}`}>
      <img src={cat.img} alt={cat.name} className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#121212]/60 via-transparent to-transparent" />
      <div className="absolute bottom-7 left-7 right-7 flex items-end justify-between">
        <h3 className="font-serif font-light text-3xl md:text-4xl text-[#F8F7F4]">{cat.name}</h3>
        <span className="text-[11px] uppercase tracking-[0.15em] text-[#F8F7F4] flex items-center gap-2 opacity-80 group-hover:opacity-100 group-hover:gap-3 transition-all">
          Comprar <ArrowRight size={15} />
        </span>
      </div>
    </Link>
  );
}
